<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
.el-date-editor .el-range-separator{
  padding: 0 1px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue